import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'umss-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UmssTableComponent {
  @Input() density: 'Regular' | 'Compact' = 'Regular';
  @Input() fullWidth = true;
  @Input() bordered = true;
}
